import React, { useEffect, useState } from "react";
import {
  getMedicalHistorySummary,
  getSocialPersonalHistorySummary,
} from "../Helpers/API/ReportsApi/ReportsApi";
import { SOCIAL_PROFILE_NAMES } from "./historyProfileNames";
import { formatDateWithTime } from "../Helpers/Utilities/Common";
import { Table } from "antd";
import { useParams } from "react-router-dom";
import { autoFormatDateCell } from "../../Utils/dateFormat";

export default function SocialPersonalHistorySummary({
  isVisible,
  setIsSelected,
  setIsMedicalHistory,
  setSelectedItem,
}) {
  const { id } = useParams();
  const [showLoader, setShowLoader] = useState(false);
  const [summary, setSummary] = useState([]);

  const handleRowClick = (record) => {
    setIsMedicalHistory(false);
    if (record.name === "Smoking Profile") {
      setIsSelected("Smoking");
      setSelectedItem(0);
    } else if (record.name === "Drinking Profile") {
      setIsSelected("Drinking");
      setSelectedItem(1);
    } else if (
      record.name === "Illicit Drug Use Profile" ||
      record.name === "Drug Use Profile"
    ) {
      setIsSelected("Illicit Drug Use");
      setSelectedItem(2);
    } else if (record.name === "Herbal Use Profile") {
      setIsSelected("Herbal Use");
      setSelectedItem(3);
    } else if (record.name === "Sexual Activity Profile") {
      setIsSelected("Sexual Activity");
      setSelectedItem(4);
    }
  };

  async function get() {
    setShowLoader(true);
    const [socialRes, medRes] = await Promise.all([
      getSocialPersonalHistorySummary(id),
      getMedicalHistorySummary(id),
    ]);

    const mergedByName = new Map();

    const ingest = (rows) => {
      (rows || []).forEach((med) => {
        if (!SOCIAL_PROFILE_NAMES.has(med.name)) return;
        const existing = mergedByName.get(med.name);
        if (!existing) {
          mergedByName.set(med.name, med);
          return;
        }
        const existingTime = new Date(existing.added_on).getTime();
        const nextTime = new Date(med.added_on).getTime();
        if (nextTime >= existingTime) {
          mergedByName.set(med.name, med);
        }
      });
    };

    if (socialRes.data?.data) ingest(socialRes.data.data);
    if (medRes.data?.data) ingest(medRes.data.data);

    const _parsed = Array.from(mergedByName.values())
      .sort(
        (a, b) =>
          new Date(b.added_on).getTime() - new Date(a.added_on).getTime()
      )
      .map((med) => ({
        ...med,
        added_on: formatDateWithTime(med.added_on),
      }));

    setSummary(_parsed);
    setShowLoader(false);
  }

  useEffect(() => {
    get();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
  return (
    <Table
      columns={[
        { title: "Social/Personal", dataIndex: "name" },
        { title: "Latest Date", dataIndex: "added_on", render: (value) => autoFormatDateCell("added_on", value) ?? value },
      ]}
      onRow={(record) => ({
        onClick: () => handleRowClick(record),
      })}
      dataSource={summary}
      size="small"
      loading={showLoader}
    />
  );
}
